import React, { useEffect } from "react";
import Grid from "@material-ui/core/Grid";
import EntityDialog from "../../components/EntityDialog";
import ErrorBoundary from "../../components/ErrorBoundary";
import { useDropzone } from "reactcoregk/hooks";
import HiDrop from "../../components/HiDrop";
import Title from "../../components/Common/Title";
import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";
import Divider from "@material-ui/core/Divider";
import Button from "@material-ui/core/Button";
import { makeStyles } from "@material-ui/core/styles";
import GetAppIcon from "@material-ui/icons/GetApp";
import { downloadFile } from "../../helpers/utils";
import { API_URL } from "../../config";

const useStyles = makeStyles({
  link: {
    fontSize: 14,
    display: "flex",
    alignItems: "center",
  },
});

const UploadCveDialog = (props) => {
  const classes = useStyles();
  const { open } = props;

  const {
    handleAcceptedFiles,
    setSelectedFiles,
    selectedFiles,
  } = useDropzone();

  useEffect(() => {
    if (open) {
      setSelectedFiles([]);
    }
  }, [open, setSelectedFiles]);

  const handleCsvDownload = async () => {
    try {
      await downloadFile(
        API_URL + "/api/cverisk/download-template/full-sync",
        "CVE Definition Template",
        "csv"
      );
    } catch (e) {
      console.log(e);
    }
  };

  const handleUpload = () => {
    const formData = new FormData();
    formData.append("cves", selectedFiles[0]);
    props.createEntity(formData);
  };

  return (
    <EntityDialog
      form={{}}
      titleOverride={"Upload CVE"}
      showProgress
      maxWidth={"sm"}
      {...props}
      createEntity={handleUpload}
    >
      <ErrorBoundary>
        <Grid container direction={"column"} spacing={1}>
          <Grid item>
            <Title>Add CVE definition from csv</Title>
          </Grid>
          <Box mt={2} />
          <Grid item>
            <Grid container spacing={2} alignItems={"center"}>
              <Grid item>
                <Typography
                  color={"textSecondary"}
                  style={{ display: "flex", alignItems: "center" }}
                >
                  Upload CSV{" "}
                </Typography>
              </Grid>
              <Grid item>
                <Divider orientation={"vertical"} style={{ height: 14 }} />
              </Grid>
              <Grid item>
                <Button
                  color={"primary"}
                  size={"small"}
                  className={classes.link}
                  onClick={handleCsvDownload}
                >
                  <GetAppIcon /> Download template
                </Button>
              </Grid>
            </Grid>
          </Grid>
          <div style={{ height: 250 }}>
            <HiDrop
              selectedFiles={selectedFiles}
              handleAcceptedFiles={handleAcceptedFiles}
              title={"Drag and drop CSV"}
              setSelectedFiles={setSelectedFiles}
              link={"Upload file"}
              accept=".csv, application/vnd.ms-excel, text/csv"
            />
          </div>
        </Grid>
      </ErrorBoundary>
    </EntityDialog>
  );
};

export default UploadCveDialog;
